import React from 'react';

const PolicyLinks = () => (
  <p className='auth-policy-links'>
    登录/注册视为您已同意 MoRouter{' '}
    <a href='/policy.txt' target='_blank' rel='noreferrer'>服务政策协议</a>
    {' '}与{' '}
    <a href='/privacy.txt' target='_blank' rel='noreferrer'>用户隐私协议</a>
  </p>
);

export default PolicyLinks;
